import { render, staticRenderFns } from "./EmergencycontactsHRM.vue?vue&type=template&id=33e19a6e&"
import script from "./EmergencycontactsHRM.vue?vue&type=script&lang=js&"
export * from "./EmergencycontactsHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports